module.exports = __webpack_public_path__ + "img/select.18bbf780.svg";